import React from 'react';
import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';

import { getVideoUrl } from 'lib/getVideoUrl';
import Carousel from './Carousel';

const isYouTubeUrl = (url: string) => {
  return url.includes('youtube.com') || url.includes('youtu.be');
};

const PopUpTour: React.FC<{ tours?: string[] | string | null }> = ({
  tours,
}) => {
  const more639 = useMediaQuery('(min-width: 639px)');

  // Check if videos are YouTube videos
  const isYouTube = React.useMemo(() => {
    if (Array.isArray(tours)) {
      return tours.some((url) => isYouTubeUrl(url));
    } else if (tours) {
      return isYouTubeUrl(tours);
    }
    return false;
  }, [tours]);

  return (
    <div
      className={classNames(
        'md:pr-[35px] md:pl-[36px] overflow-y-auto  md:pb-60 lg:pb-0 flex justify-center items-baseline h-full',
        {
          'pl-[11px] pr-[12px]': !more639,
          'pl-[24px] pr-[25px]': !!more639,
        }
      )}
    >
      <div className="relative video-popup w-full max-h-full">
        {Array.isArray(tours) ? (
          <Carousel
            emblaOptions={{
              loop: true,
            }}
            fullWidthSlides={true}
            showArrows={true}
            className={classNames('tour-video-carousel', {
              'tour-video-carousel-youtube': isYouTube,
            })}
          >
            {tours.map((url) => {
              let videoUrl = getVideoUrl(url);
              videoUrl.searchParams.append('enablejsapi', '1');
              return (
                <div
                  className="flex justify-center items-center w-full h-full"
                  key={url}
                >
                  <div className="w-full aspect-video">
                    <iframe
                      className="w-full h-full iframe-landscape-height"
                      src={videoUrl.toString()}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                      allowFullScreen
                    />
                  </div>
                </div>
              );
            })}
          </Carousel>
        ) : tours ? (
          <div className="w-full aspect-video">
            <iframe
              src={
                tours.includes('watch')
                  ? tours.replace('watch?v=', 'embed/')
                  : tours.includes('youtu.be')
                  ? tours.replace('youtu.be', 'www.youtube.com/embed/')
                  : tours.includes('dropbox')
                  ? tours.replace('dl=0', 'raw=1')
                  : tours
              }
              className="w-full h-full iframe-landscape-height"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PopUpTour;
